import { TypeOfMessage, useMessagesStore } from '@/store/messages'
import { Message, MessageParams } from './message.type'
import { getLocaleValueFor } from '@/helpers/locale.helper'

const titleGenericLocalKey = 'MESSAGE_GENERIC_TITLE'
const msgGenericLocalKey = 'MESSAGE_GENERIC_MESSAGE'

function sendMessageToUser(message: Message) {
  useMessagesStore().setMessage({
    show: true,
    typeOfMessage: message.type,
    title: message.title,
    msg: message.msg,
    action: () => {
      return 0
    },
  })
}

// Generic fallback title: "<type> - <generic title>". Resolved lazily so the
// generic locale keys are only looked up when no specific title is provided.
function getGenericTitle(typeOfMessage: TypeOfMessage): string {
  return `${getLocaleValueFor(typeOfMessage)} - ${getLocaleValueFor(
    titleGenericLocalKey,
  )}`
}

function getMessageFromParams(
  params: MessageParams,
  typeOfMessage: TypeOfMessage,
): Message {
  let title: string
  if (params.titleLocaleKey) {
    try {
      title = getLocaleValueFor(params.titleLocaleKey, true)
    } catch (error) {
      console.warn(error)
      title = getGenericTitle(typeOfMessage)
    }
  } else {
    title = params.title || getGenericTitle(typeOfMessage)
  }
  let msg: string
  if (params.msgLocaleKey) {
    try {
      msg = getLocaleValueFor(params.msgLocaleKey, true)
    } catch (error) {
      console.warn(error)
      msg = getLocaleValueFor(msgGenericLocalKey)
    }
  } else {
    msg = params.msg || getLocaleValueFor(msgGenericLocalKey)
  }
  if (params.msgDynamicValues) {
    params.msgDynamicValues.forEach((value, index) => {
      msg = msg.replace(`{${index}}`, value)
    })
  }
  return {
    type: typeOfMessage,
    title,
    msg,
  }
}

export function sendInfoMessageToUser(params: MessageParams) {
  const paramsFormatted = getMessageFromParams(params, TypeOfMessage.Info)
  sendMessageToUser(paramsFormatted)
}

export function sendWarningMessageToUser(params: MessageParams) {
  const paramsFormatted = getMessageFromParams(params, TypeOfMessage.Warning)
  sendMessageToUser(paramsFormatted)
}

export function sendErrorMessageToUser(params: MessageParams) {
  const paramsFormatted = getMessageFromParams(params, TypeOfMessage.Error)
  sendMessageToUser(paramsFormatted)
}

export function sendOkCenteredMessageToUser(params: MessageParams) {
  const paramsFormatted = getMessageFromParams(params, TypeOfMessage.OkCentered)
  sendMessageToUser(paramsFormatted)
}
